import { getServerRequest, putServerRequest, deleteServerRequest } from '@/helpers/serverRequest.helper';
import { store } from '@/store/store';

const httpURL = store.getters.httpURL;

export const cargarDocumentosDeparaService = async (idDepara) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/depara/documentos/${idDepara}`;
    return await getServerRequest(url, config);
}

export const subirDocumentoService = async (idDepara, formData, uploadHandler) => {
    const token = store.getters.sessionToken;
    const config = {
        headers: {
            token,
            'Content-Type': 'multipart/form-data'
        },
        ...uploadHandler
    };
    const url = `${httpURL}/oficios/depara/documento/${idDepara}`;
    return await putServerRequest(url, formData, config);
}

export const previsualizarDocumentoService = async (idDocumento) => {
    const token = store.getters.sessionToken;
    const config = {
        responseType: 'blob', // important
        data: {},
        headers: { token },
    };
    const url = `${httpURL}/oficios/depara/documento/${idDocumento}`;
    return await getServerRequest(url, config);
}

export const eliminarDocumentoService = async (idDocumento) => {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/oficios/depara/documento/${idDocumento}`;
    return await deleteServerRequest(url, config);
}